import { useMutation } from "@tanstack/react-query";
import { UseMutationOptions } from "@tanstack/react-query/src/types";
import { useGlobalDialogState } from "../dialog/GlobalDialogState";
import { useGlobalProgressState } from "../progress/GlobalProgressState";

export const useMutationAlertError = <TData = unknown, TError = unknown, TVariables = void, TContext = unknown>(
    options: UseMutationOptions<TData, TError, TVariables, TContext>
) => {
    const globalDialogState = useGlobalDialogState();
    const mutationFn = async (variables: TVariables) => await options.mutationFn(variables);

    return useMutation({
        mutationFn,
        ...options,
        onError: async (error, variables, context) => {
            await globalDialogState.addErrorAlertDialog(error as unknown as Error, true);
            await options.onError?.(error, variables, context);
        },
    });
};
export const useMutationTrackAndAlertError = <TData = unknown, TError = unknown, TVariables = void, TContext = unknown>(
    options: UseMutationOptions<TData, TError, TVariables, TContext>,
    loadingMessage?: string
) => {
    const globalDialogState = useGlobalDialogState();
    const track = useGlobalProgressState((s) => s.track);

    const mutationFn = async (variables: TVariables) => await track(options.mutationFn(variables), loadingMessage, false);

    return useMutation({
        ...options,
        mutationFn,
        onError: async (error, variables, context) => {
            await globalDialogState.addErrorAlertDialog(error as unknown as Error, true);
            await options.onError?.(error, variables, context);
        },
    });
};
